import Vue from "vue";
import VueRouter from "vue-router";

import { guest } from "@/router/guest";
// import {checkout} from "@/router/checkout";
import { userRoute } from "@/router/userRoute";
import { userRoutes } from "./user";

Vue.use(VueRouter);

const CHUNK_RELOAD_KEY = "boldd:chunk-reload-attempted";

const isChunkLoadError = (error) => {
  const message = error?.message || "";

  return (
    /Loading chunk [\d]+ failed/i.test(message) ||
    /ChunkLoadError/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
};

const isIgnorableNavigationError = (error) => {
  if (!error) return false;
  const name = String(error.name || "");
  const message = String(error.message || "");
  return (
    name === "NavigationDuplicated" ||
    name === "NavigationCancelled" ||
    name === "NavigationAborted" ||
    name === "NavigationRedirected" ||
    /Avoided redundant navigation/i.test(message) ||
    /Navigation cancelled/i.test(message)
  );
};

const routes = [
  //guest routes
  ...guest,

  //user routes
  ...userRoute,

  {
    name: "layout",
    path: "/account",
    component: () =>
      import(/* webpackChunkName: "layout"*/ "../views/user/index.vue"),
    children: [...userRoutes],
  },

  //403 error
  {
    name: "unauthorized",
    path: "/forbidden",
    component: () =>
      import(/*webpackChunkName: "unauthorized"*/ "@/views/error/unauthorized"),
  },
  {
    name: "notFound",
    path: "*",
    component: () =>
      import(/*webpackChunkName: "error"*/ "@/views/error/notFound"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((error) => {
    if (isIgnorableNavigationError(error)) return error;
    throw error;
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((error) => {
    if (isIgnorableNavigationError(error)) return error;
    throw error;
  });
};

router.onError((error) => {
  if (!isChunkLoadError(error)) {
    console.error(error);
    return;
  }

  const hasRetried = sessionStorage.getItem(CHUNK_RELOAD_KEY) === "true";

  if (hasRetried) {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    console.error(error);
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
  window.location.reload();
});

router.afterEach(() => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

export default router;
